<script lang="ts" module>
	import coursesLogoCs from "@assets/images/courses-logo-cs.png?webp&w=287&imagetools";
	import coursesLogoEn from "@assets/images/courses-logo-en.png?webp&w=287&imagetools";
	import coffeeCardImage from "@assets/images/fathers-family-bags.png?webp&w=800&imagetools";
	import contactImageXs from "@assets/images/fathers-family-club-last.jpg?webp&h=1000&imagetools";
	import contactImageSm from "@assets/images/fathers-family-club-last.jpg?webp&h=1300&imagetools";
	import contactImageLg from "@assets/images/fathers-family-club-last.jpg?webp&h=1600&imagetools";
	import contactImage3xl from "@assets/images/fathers-family-club-last.jpg?webp&imagetools";
	import heroImageXs from "@assets/images/gift-subscription-cafe.jpg?webp&h=1000&quality=95&imagetools";
	import heroImageSm from "@assets/images/gift-subscription-cafe.jpg?webp&h=1300&quality=95&imagetools";
	import heroImageLg from "@assets/images/gift-subscription-cafe.jpg?webp&h=1600&imagetools";
	import heroImageXl from "@assets/images/gift-subscription-cafe.jpg?webp&h=1900&imagetools";
	import heroImage3xl from "@assets/images/gift-subscription-cafe.jpg?webp&imagetools";
	import giftSubscriptionBanner3Xl from "@assets/images/gift-subscription-hero.jpg?webp&imagetools";
	import giftSubscriptionBannerXs from "@assets/images/gift-subscription-hero.jpg?webp&w=960&h=1000&imagetools";
	import giftSubscriptionBannerSm from "@assets/images/gift-subscription-hero.jpg?webp&w=1280&h=1000&imagetools";
	import giftSubscriptionBannerMd from "@assets/images/gift-subscription-hero.jpg?webp&w=1600&imagetools";
	import giftSubscriptionBannerLg from "@assets/images/gift-subscription-hero.jpg?webp&w=1920&imagetools";
	import giftSubscriptionBanner2Xl from "@assets/images/gift-subscription-hero.jpg?webp&w=2400&imagetools";
	import giftSubscriptionLogoCs from "@assets/images/gift-subscription-logo-cs.png?webp&w=900&imagetools";
	import giftSubscriptionLogoEn from "@assets/images/gift-subscription-logo-en.png?webp&w=900&imagetools";
	import giftSubscriptionCardImage from "@assets/images/gift-subscription-photo.jpg?webp&w=800&imagetools";
	import voucherCardImage from "@assets/images/holding-cups.jpg?webp&w=800&imagetools";
	import homeCourseCardImage from "@assets/images/home-filter-coffee-hero.webp?webp&w=800&imagetools";
	import coursesBanner3Xl from "@assets/images/homepage-courses.jpg?webp&imagetools";
	import coursesBannerXs from "@assets/images/homepage-courses.jpg?webp&w=960&h=1000&imagetools";
	import coursesBannerSm from "@assets/images/homepage-courses.jpg?webp&w=1280&h=1000&imagetools";
	import coursesBannerMd from "@assets/images/homepage-courses.jpg?webp&w=1600&imagetools";
	import coursesBannerLg from "@assets/images/homepage-courses.jpg?webp&w=1920&imagetools";
	import coursesBanner2Xl from "@assets/images/homepage-courses.jpg?webp&w=2400&imagetools";
	import baristaCourseCardImage from "@assets/images/sca-foundation-hero.jpg?webp&w=800&imagetools";
	import ChristmasOfferCard from "@components/ChristmasOfferCard.svelte";
	import GiftSubscriptionButton from "@components/GiftSubscriptionButton.svelte";
	import { ButtonSize } from "@components/common/ButtonSize.js";
	import Formatted from "@components/common/Formatted.svelte";
	import Heading from "@components/common/Heading.svelte";
	import Link from "@components/common/Link.svelte";
	import StructuredData from "@components/common/StructuredData.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import BenefitsStrip from "@components/sections/BenefitsStrip.svelte";
	import HandwrittenBanner from "@components/sections/HandwrittenBanner.svelte";
	import ImageSection from "@components/sections/ImageSection.svelte";
	import ProductSection from "@components/sections/ProductSection.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import type { ItemList as SchemaItemList, WithContext as SchemaWithContext } from "schema-dts";
	import { ButtonVariant } from "@core/schema/ButtonVariant.js";
	import { CategoryType } from "@core/schema/CategoryType.js";
	import { CourseType } from "@core/schema/CourseType.js";
	import { Locale, type LocalizedString } from "@core/schema/Locale.js";
	import { getCategoryPath } from "@core/schema/paths/getCategoryPath.js";
	import { getChristmasOfferAnchor } from "@core/schema/paths/getChristmasOfferAnchor.js";
	import { getContactPath } from "@core/schema/paths/getContactPath.js";
	import { getCourseTypePath } from "@core/schema/paths/getCourseTypePath.js";
	import { getCoursesListingPath } from "@core/schema/paths/getCoursesListingPath.js";
	import { getGiftSubscriptionPath } from "@core/schema/paths/getGiftSubscriptionPath.js";
	import { getPurchasableCouponsListingPath } from "@core/schema/paths/getPurchasableCouponsListingPath.js";
	import { idFromAnchor } from "@core/schema/utils/idFromAnchor.js";
	import { tw } from "@core/utils/svelte/tw.js";
	import { getGlobalSettings } from "../contexts/getGlobalSettings.js";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import translations from "./Christmas.translations.json" with { type: "json" };
	import type { ChristmasProps } from "./ChristmasProps.js";

	type OfferKey = "coffee" | "voucher" | "giftSubscription" | "baristaCourse" | "homeCourse";

	interface OfferItem {
		key: OfferKey;
		href: string;
		image: string;
	}

	const coursesLogoMap: LocalizedString = {
		[Locale.cs]: coursesLogoCs,
		[Locale.en]: coursesLogoEn,
	};
	const giftSubscriptionLogoMap: LocalizedString = {
		[Locale.cs]: giftSubscriptionLogoCs,
		[Locale.en]: giftSubscriptionLogoEn,
	};
	const heroImageHeight = tw("!h-[max(calc(100vh-8rem),32rem)]");
	const contactImageHeight = tw("!min-h-0 !h-[max(55vh,28rem)]");
	const fullHeightContent = tw("!grid-rows-[1fr] [&>*]:min-h-0");
</script>

<script lang="ts">
	const translate = getTranslate(translations);
	const settings = getGlobalSettings();
	const { tenant } = getGlobalTemplateProps();
	const { products, subcategories }: ChristmasProps = $props();
	const offerAnchor = getChristmasOfferAnchor(tenant.locale);

	const offerItems: OfferItem[] = [
		{ key: "coffee", href: getCategoryPath(tenant.locale, CategoryType.Coffee), image: coffeeCardImage },
		{ key: "voucher", href: getPurchasableCouponsListingPath(tenant), image: voucherCardImage },
		{ key: "giftSubscription", href: getGiftSubscriptionPath(tenant), image: giftSubscriptionCardImage },
		{
			key: "baristaCourse",
			href: getCourseTypePath(tenant.locale, CourseType.SCAFoundation),
			image: baristaCourseCardImage,
		},
		{ key: "homeCourse", href: getCoursesListingPath(tenant), image: homeCourseCardImage },
	];

	const offerList: SchemaWithContext<SchemaItemList> = {
		"@context": "https://schema.org",
		"@type": "ItemList",
		name: translate("introTitle"),
		itemListElement: offerItems.map(({ key, href }, index) => ({
			"@type": "ListItem",
			position: index + 1,
			name: translate(`${key}Title`),
			url: `${settings.WEB_URL_OR_LOCAL}${href}`,
		})),
	};
</script>

<Layout transparentHeader ogImage={heroImageSm}>
	<StructuredData data={offerList} />

	<ImageSection
		lcp
		darkOverlay="!bg-black/40"
		contentAlign="left"
		class={heroImageHeight}
		innerClass={fullHeightContent}
		media="object-[50%_60%]"
		sources={{
			default: heroImageXs,
			">sm": heroImageSm,
			">lg": heroImageLg,
			">xl": heroImageXl,
			">3xl": heroImage3xl,
		}}
	>
		{#snippet heading()}
			<div class="flex h-full max-w-140 flex-col items-start justify-center gap-4 md:gap-6">
				<Heading level={1} text={translate("heroTitle")} class="heading-1 text-white" />
				<p class="text-white/80 max-w-105 text-sm/normal sm:text-lg/normal">
					<Formatted text={translate("heroLead")} />
				</p>
				<Link href={offerAnchor} size={ButtonSize.Medium} variant={ButtonVariant.White} class="mt-2 md:mt-4">
					<Formatted text={translate("heroCta")} />
				</Link>
			</div>
		{/snippet}
	</ImageSection>

	<BenefitsStrip items={[translate("benefitFresh"), translate("benefitGift"), translate("benefitFamily")]} />

	<section class="py-14 sm:py-17 md:py-20 grid gap-6 lg:grid-cols-2 lg:gap-16 lg:items-center">
		<div class="flex flex-col">
			<div class="uppercase text-fcrorange font-bold tracking-[.1em]">
				<Formatted text={translate("introLabel")} />
			</div>
			<Heading level={2} text={translate("introTitle")} class="heading-2 text-fcrdarkgray mt-4" />
		</div>
		<p class="text-sm/normal sm:text-lg/normal text-fcrgray">
			<Formatted text={translate("introText")} />
		</p>
	</section>

	<section id={idFromAnchor(offerAnchor)} class="scroll-mt-24 pb-14 sm:pb-17 md:pb-20">
		<div class="grid gap-x-4 gap-y-12 sm:grid-cols-2 md:gap-x-8 md:gap-y-14 xl:grid-cols-3">
			{#each offerItems as { key, href, image } (key)}
				<ChristmasOfferCard
					{href}
					{image}
					title={translate(`${key}Title`)}
					text={translate(`${key}Text`)}
					cta={translate(`${key}Cta`)}
				/>
			{/each}
		</div>
	</section>

	<ProductSection
		{subcategories}
		{products}
		title="[{getCategoryPath(tenant.locale, CategoryType.Coffee)}][[{translate('productsTitle')}]]"
		class="bg-fcrbeige"
	/>

	<div class="grid lg:!grid-cols-2 full-width">
		<HandwrittenBanner
			topAligned
			title={translate("courses")}
			tagline={translate("coursesTagline")}
			lettering={{ src: coursesLogoMap[tenant.locale], width: 314, height: 225 }}
			media="object-[0%_51%]"
			sources={{
				default: coursesBannerXs,
				">sm": coursesBannerSm,
				">md": coursesBannerMd,
				">lg": coursesBannerLg,
				">xl": coursesBannerLg,
				">2xl": coursesBanner2Xl,
				">3xl": coursesBanner3Xl,
			}}
		>
			{#snippet actions()}
				<Link size={ButtonSize.Medium} variant={ButtonVariant.White} href={getCoursesListingPath(tenant)}>
					<Formatted text={translate("coursesMore")} />
				</Link>
			{/snippet}
		</HandwrittenBanner>
		<HandwrittenBanner
			topAligned
			darkOverlay
			title={translate("giftSubscription")}
			tagline={translate("giftSubscriptionTagline")}
			lettering={{ src: giftSubscriptionLogoMap[tenant.locale], width: 410, height: 230 }}
			sources={{
				default: giftSubscriptionBannerXs,
				">sm": giftSubscriptionBannerSm,
				">md": giftSubscriptionBannerMd,
				">lg": giftSubscriptionBannerLg,
				">xl": giftSubscriptionBannerLg,
				">2xl": giftSubscriptionBanner2Xl,
				">3xl": giftSubscriptionBanner3Xl,
			}}
		>
			{#snippet actions()}
				<GiftSubscriptionButton variant={ButtonVariant.White} />
			{/snippet}
		</HandwrittenBanner>
	</div>

	<ImageSection
		darkOverlay="!bg-black/40"
		contentAlign="left"
		class={contactImageHeight}
		innerClass={fullHeightContent}
		sources={{
			default: contactImageXs,
			">sm": contactImageSm,
			">lg": contactImageLg,
			">3xl": contactImage3xl,
		}}
	>
		{#snippet heading()}
			<div class="flex h-full max-w-140 flex-col items-start justify-center gap-4 md:gap-6">
				<Heading level={2} text={translate("contactTitle")} class="heading-1 text-white" />
				<p class="text-white/80 max-w-105 text-sm/normal sm:text-lg/normal">
					<Formatted text={translate("contactText")} />
				</p>
				<Link href={getContactPath(tenant)} size={ButtonSize.Medium} variant={ButtonVariant.White} class="mt-2">
					<Formatted text={translate("contactCta")} />
				</Link>
			</div>
		{/snippet}
	</ImageSection>
</Layout>
